if (!window.hasOwnProperty("fetch")) {
  window.outdatedBrowser = true;
} else {
  window.configPromise = fetch("/config.json");
}
